export default "__VITE_ASSET__CIfY5KQd__"